import { render, staticRenderFns } from "./eformel.vue?vue&type=template&id=b804a618&"
import script from "./eformel.vue?vue&type=script&lang=js&"
export * from "./eformel.vue?vue&type=script&lang=js&"
import style0 from "./eformel.vue?vue&type=style&index=0&id=b804a618&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports